import { FC, PropsWithChildren } from 'react';

type Props = {
	className?: string;
};

const AntiguaAndBarbudaFlagIcon: FC<PropsWithChildren<Props>> = ({
	className,
}) => {
	return (
		<svg
			width='20'
			height='14'
			viewBox='0 0 20 14'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={`${className}`}>
			<rect
				width='20'
				height='14'
				rx='2'
				fill='white'
			/>
			<mask
				id='mask0_2332_14221'
				style={{ maskType: 'luminance' }}
				maskUnits='userSpaceOnUse'
				x='0'
				y='0'
				width='20'
				height='14'>
				<rect
					width='20'
					height='14'
					rx='2'
					fill='white'
				/>
			</mask>
			<g mask='url(#mask0_2332_14221)'>
				<rect
					width='20'
					height='14'
					fill='#E2243B'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 0H20L10 14L0 0Z'
					fill='#262626'
				/>
				<mask
					id='mask1_2332_14221'
					style={{ maskType: 'luminance' }}
					maskUnits='userSpaceOnUse'
					x='0'
					y='0'
					width='20'
					height='14'>
					<path
						fillRule='evenodd'
						clipRule='evenodd'
						d='M0 0H20L10 14L0 0Z'
						fill='white'
					/>
				</mask>
				<g mask='url(#mask1_2332_14221)'>
					<g filter='url(#filter0_d_2332_14221)'>
						<path
							fillRule='evenodd'
							clipRule='evenodd'
							d='M10.0006 7.70002L8.36049 9.48032L8.48533 7.08495L6.04107 7.20729L7.8577 5.60002L5.71484 3.73336L8.48533 4.20002L8.0958 1.40002L10.0006 3.73336L11.9053 1.40002L11.5158 4.20002L14.2863 3.73336L12.1434 5.60002L13.96 7.20729L11.5158 7.08495L11.6406 9.48032L10.0006 7.70002Z'
							fill='#FFCF3C'
						/>
					</g>
					<g filter='url(#filter1_d_2332_14221)'>
						<path
							fillRule='evenodd'
							clipRule='evenodd'
							d='M0 9.33331H20V5.59998H0V9.33331Z'
							fill='#1984D8'
						/>
					</g>
					<path
						fillRule='evenodd'
						clipRule='evenodd'
						d='M0 14H20V9.33337H0V14Z'
						fill='white'
					/>
				</g>
			</g>
			<defs>
				<filter
					id='filter0_d_2332_14221'
					x='5.71484'
					y='1.40002'
					width='8.57227'
					height='8.08032'
					filterUnits='userSpaceOnUse'
					colorInterpolationFilters='sRGB'>
					<feFlood
						floodOpacity='0'
						result='BackgroundImageFix'
					/>
					<feColorMatrix
						in='SourceAlpha'
						type='matrix'
						values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
						result='hardAlpha'
					/>
					<feOffset />
					<feColorMatrix
						type='matrix'
						values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0'
					/>
					<feBlend
						mode='normal'
						in2='BackgroundImageFix'
						result='effect1_dropShadow_2332_14221'
					/>
					<feBlend
						mode='normal'
						in='SourceGraphic'
						in2='effect1_dropShadow_2332_14221'
						result='shape'
					/>
				</filter>
				<filter
					id='filter1_d_2332_14221'
					x='0'
					y='5.59998'
					width='20'
					height='3.73328'
					filterUnits='userSpaceOnUse'
					colorInterpolationFilters='sRGB'>
					<feFlood
						floodOpacity='0'
						result='BackgroundImageFix'
					/>
					<feColorMatrix
						in='SourceAlpha'
						type='matrix'
						values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
						result='hardAlpha'
					/>
					<feOffset />
					<feColorMatrix
						type='matrix'
						values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0'
					/>
					<feBlend
						mode='normal'
						in2='BackgroundImageFix'
						result='effect1_dropShadow_2332_14221'
					/>
					<feBlend
						mode='normal'
						in='SourceGraphic'
						in2='effect1_dropShadow_2332_14221'
						result='shape'
					/>
				</filter>
			</defs>
		</svg>
	);
};

export default AntiguaAndBarbudaFlagIcon;
